export default __webpack_public_path__ + "static/media/review8.fe564de6.jpg";